module.exports = __webpack_public_path__ + "media/images/recipes/entrecote-2e139a2e7d629322bf14c85dae21453f.pdf";